import { gql } from '@apollo/client';
import React, { useMemo } from 'react';
import classNames from 'classnames';
import { getActiveVariantBy } from '../../../../../lib/getActiveVariantBy';
import { ColorSelector, COLOR_SELECTOR_FRAGMENT } from '../../../../ColorSelector';
import { VariantCellColorSelectorFragment } from '../../../../../generated/types/VariantCellColorSelectorFragment';

import './VariantCellColorSelector.scss';

export const VARIANT_CELL_COLOR_SELECTOR_FRAGMENT = gql`
  fragment VariantCellColorSelectorFragment on Variant {
    ...ColorSelectorFragment
  }
  ${COLOR_SELECTOR_FRAGMENT}
`;

type Props = {
  variant: VariantCellColorSelectorFragment;
  activeVariantId: string;
  onSelectColor(color: string): void;
  className?: string;
};

export const VariantCellColorSelector: React.FC<Props> = ({
  className,
  variant,
  onSelectColor,
  activeVariantId
}) => {
  const { color } = useMemo(() => getActiveVariantBy(variant, 'id', activeVariantId), [
    activeVariantId,
    variant
  ]);

  return (
    <ColorSelector
      size="small"
      className={classNames('VariantCellColorSelector', className)}
      variant={variant}
      onSelect={onSelectColor}
      selected={color}
    />
  );
};
